import { useQuery } from 'react-query'
import axios from 'axios'
import { NvResponse, RequestName, RequestURL } from '../baseModels'
import { createG2Request } from '../createRequest'
import { OrderPriceSummary } from './orderPriceSummary'
import { useRestaurantContext } from '../../contexts/RestaurantContext'

export const GetOrderPriceSummaryQueryKey = 'getOrderPriceSummary'

const getOrderPriceSummary = async (
  restaurantGuid: string,
  bookingGuid: string
): Promise<OrderPriceSummary> => {
  return axios
    .request<NvResponse<OrderPriceSummary>>(
      createG2Request(
        RequestURL[RequestName.GET_BOOKING_ORDER_PRICE_SUMMARY],
        { 'Toast-Restaurant-External-ID': restaurantGuid },
        {},
        { bookingGuid: bookingGuid }
      )
    )
    .then((response) => response.data.results[0])
}

export const useGetOrderPriceSummary = (bookingGuid: string | null) => {
  const { restaurantGuid } = useRestaurantContext()
  return useQuery(
    [GetOrderPriceSummaryQueryKey, bookingGuid],
    () => getOrderPriceSummary(restaurantGuid, bookingGuid!),
    { enabled: Boolean(bookingGuid) }
  )
}
